export const ACCOUNTS_ENDPOINT = '/accounts';
